import React, {Component} from 'react';
import {Container, Row} from "react-grid-system";
import Card from "./Cards/Card";

class Cards extends Component {

    render() {
        return (
            <Container fluid={true} style={{marginTop: '30px'}}>
                <Row>
                    {this.props.voting.data.map((entry) => {
                        return (
                            <Card entry={entry} key={entry.id}>
                                No format
                            </Card>
                        )
                    })}
                </Row>
            </Container>
        );
    }
}

export default Cards;


// WEBPACK FOOTER //
// ./src/Components/Cards.js